<template>
	<div class="games-fps-estimation">
		<div class="container">
			<div class="games-and-measurement">
				<div class="games">
					<template v-for="game in games">
						<game-fps-counter :game="game" :key="game.id" />
					</template>
				</div>
				<div class="guaranteed-fps">
					<h1>{{ landingPageSections2.title | stripTags }}</h1>
					<p>{{ landingPageSections2.body | stripTags }}</p>
					<resolution-switch class="hidden-xs hidden-sm" />
					<transition name="fade">
						<span v-if="shouldShowUnsatisfiedFps" class="unsatisfied-fps hidden-xs hidden-sm">
							Unsatisfied with FPS? <a @click.prevent="$router.push({ name: 'step2' })" href="#">Increase your budget</a>
						</span>
					</transition>
				</div>

				<div class="pending-fps-msg" v-if="showFpsPendingMobile">
					<h5>FPS pending</h5>
					<p>{{ fpsPendingMessage }}</p>
				</div>

				<resolution-switch class="hidden-md hidden-lg" />
				<transition name="fade">
					<span v-if="shouldShowUnsatisfiedFps" class="unsatisfied-fps hidden-md hidden-lg">
						Unsatisfied with FPS? <a @click.prevent="$router.push({ name: 'step2' })" href="#">Increase your budget</a>
					</span>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import CONSTANTS from "@/config/constants";
import GameFpsCounter from "./game-fps-counter";
import ResolutionSwitch from "./resolution-switch";

export default {
	name: "GamesFpsEstimation",
	components: {
		GameFpsCounter,
		ResolutionSwitch
	},
	data() {
		return {
			fpsPendingMessage: CONSTANTS.FPS_PENDING_MESSAGE
		};
	},
	computed: {
		...mapState({
			games: state => state.StarterPc.games,
			resolution: state => state.StarterPc.resolution,
			landingPageSections2: state => state.StarterPc.pageData.landing_page_sections[2]
		}),
		shouldShowUnsatisfiedFps() {
			const MINIMUM_FPS = 60;
			return this.games.some(game => game[`fps_${this.resolution}`] < MINIMUM_FPS);
		},
		showFpsPendingMobile() {
			return this.games.some(game => game[`fps_${this.resolution}`] == 0);
		}
	},
	created() {
		// We're fetching the cart just to get the updated games and resolution from the step 1
		this.$store.dispatch("StarterPc/getCart");
	}
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.games-fps-estimation {
    padding: 75px;
    background-color: #24272b;
    overflow-x: hidden;

    @media (max-width: 991px) {
        padding: 25px 0;
    }

    .games-and-measurement {
        display: flex;

        @media (max-width: 991px) {
            flex-direction: column;
        }

        .games {
            display: flex;
            justify-content: center;
            flex-basis: 0;
            flex-grow: 1;
            max-width: 100%;
            position: relative;
            width: 100%;
            order: 1;

            @media (max-width: 991px) {
                order: 2;
                flex-direction: column;
                flex-basis: initial;
            }
        }

        .guaranteed-fps {
            width: 460px;
            padding: 60px 0 60px 55px;
            display: flex;
            flex-direction: column;
            flex: 0 0 auto;
            max-width: 100%;
            order: 2;

            @media (min-width: 992px) and (max-width: 1199px) {
                width: 390px;
                padding: 50px;
            }

            @media (max-width: 991px) {
                order: 1;
                padding: 0;
            }

            h1 {
                color: $white;
                font-size: 36px;
                line-height: 43px;
                margin-bottom: 10px;
                text-transform: uppercase;
                margin-top: 0;

                @media (min-width: 992px) and (max-width: 1200px) {
                    font-size: 33px;
                }
            }

            p {
                color: #b5b6b8;
                font-size: 19px;
                line-height: 28px;
                margin-bottom: 30px;

                @media (max-width: 991px) {
                    margin-bottom: 20px;
                }
            }
        }

		.pending-fps-msg {
			display: none;
			color: #FFF;
			font-size: 16px;
			letter-spacing: 0;
			line-height: 21px;
			margin: 20px 0;

			h5 {
				font-weight: bold;
				margin: 0 0 5px;
			}

			p {
				margin: 0;
			}

			@media (max-width: 991px) {
				order: 3;
				display: block;
			}
		}

        .resolution-switch {
            order: 3;

			@media (max-width: 991px) {
				order: 4;
			}
        }

        .unsatisfied-fps {
            order: 4;
            margin-top: 35px;
            font-size: 16px !important;

            @media (max-width: 991px) {
                margin-top: 10px;
				order: 5;
            }

            color: #b5b6b8 !important;

            a {
                color: $orchid;
            }
        }
    }
}
</style>
